import React from 'react';
import { Modal } from 'react-bootstrap';

const UnsavedChangesModal = ({
  show,
  onHide,
  message = 'Please save your changes before proceeding.',
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title className="text-danger">Unsaved changes</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-0">{message}</p>
      </Modal.Body>
    </Modal>
  );
};

export default UnsavedChangesModal;
